__turbopack_context__.v({
  "disclosure": "DcaqxW_disclosure",
  "fieldIcon": "DcaqxW_fieldIcon",
  "form": "DcaqxW_form",
  "icon": "DcaqxW_icon",
  "input": "DcaqxW_input",
  "panel": "DcaqxW_panel",
  "summary": "DcaqxW_summary",
});
